import { MeasurementLinkRecord, measurementLinkFromJSON } from "common/records/MeasurementLink";
import { Map, Record } from "immutable";
import { RootActions, RootState } from "common/reducers";
import { fetch, loaded, receive, reset } from "common/reducers/Utils";
import {
  RECEIVE_MEASUREMENT_LINK,
  RECEIVE_MEASUREMENT_LINKS,
  RESET_MEASUREMENT_LINK,
} from "common/reducers/measurementLink.actions";

export const MeasurementLinkStateRecord = Record({
  byId: Map<number, MeasurementLinkRecord>(),
  lastSavedById: Map<number, MeasurementLinkRecord>(),
});

export const initialState = MeasurementLinkStateRecord();
export type MeasurementLinkState = typeof initialState;

const model = "measurementLinks";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case RECEIVE_MEASUREMENT_LINK:
      return receive(state, model, measurementLinkFromJSON(action.payload.measurementLink));

    case RECEIVE_MEASUREMENT_LINKS:
      action.payload.measurementLinks.forEach((measurementLink) => {
        state = receive(state, model, measurementLinkFromJSON(measurementLink));
      });
      return state;

    case RESET_MEASUREMENT_LINK:
      return reset(state, model, action.payload.measurementLinkId);

    default:
      return state;
  }
};
